import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Icon } from 'appSrc/components/UI';
import style from './styles/style.module.css';

class SidePanel extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            additions: [],
            open: false,
        };
    }
    toggleOpen = () => {
        this.setState( { open: !this.state.open } );
    }



    render() {
        const { children } = this.props;
        const { open } = this.state;
        const className = `${ style.sidePanel } ${ this.props.className }`.trim();

        return (
            <div className={ className } data-expanded={ open }>
                <ul className={ style.firstBlock }>
                    <li onClick={ this.toggleOpen }>
                        <span className='wide' title='Collapse Menu'>
                            <Icon source='fontAwesome' icon='fas/faAngleDoubleLeft' />&nbsp;&nbsp;<span>Collapse</span>
                        </span>
                        <span className='narrow' title='Expand Menu'>
                            <Icon source='fontAwesome' icon='fas/faAngleDoubleRight' />
                        </span>
                    </li>
                </ul>
                { children }
                <ul className={ style.lastBlock }>
                    <li title='Go to DesireListTV'>
                        <Link to='/tv' style={ { opacity: '0.75', color: 'grey', pointerEvents: 'none' } }>
                            <span className='wide'><Icon source='fontAwesome' icon='fas/faFilm' />&nbsp;&nbsp;<span>DLTV</span></span>
                            <span className='narrow'>
                                <Icon source='fontAwesome' icon='fas/faFilm' />
                            </span>
                        </Link>
                    </li>
                    <li title='Go to Home Page'>
                        <Link to='/'>
                            <span className='wide'><Icon source='fontAwesome' icon='fas/faHome' />&nbsp;&nbsp;<span>Home Page</span></span>
                            <span className='narrow'>
                                <Icon source='fontAwesome' icon='fas/faHome' />
                            </span>
                        </Link>
                    </li>
                    <li title='Go to Regular Admin Panel'>
                        <Link to='/admin'>
                            <span className='wide'><Icon source='fontAwesome' icon='fas/faSlidersH' />&nbsp;&nbsp;<span>Admin Panel</span></span>
                            <span className='narrow'>
                                <Icon source='fontAwesome' icon='fas/faSlidersH' />
                            </span>
                        </Link>
                    </li>
                </ul>
            </div>
        );
    }
}
SidePanel.defaultProps = {
    className: '',
};

export default connect()( SidePanel );
